export default "__VITE_ASSET__DomtrVPv__"